import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import {
  GET_TAGS,
  EDIT_UPDATE_TAG,
  GET_TAGS_TRANSACTION,
  ADD_TAG_TRANSACTIONS,
  UPDATE_FLAG_OF_TRANSACTION,
  SET_DELETE_TAG_GQL,
  GET_ALL_TAGS_GQL,
} from '@/graphql/tags.gql';
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    tags: [],
    updatedTags: null,
    UserTransactionsTag: [],
    UserTransactionsTagForAutoCategorizaiton: [],
    tagLoagind: false,
    tagDeleted: null,
    flagOfTranUpdated: null,
    allTags: [],
  },
  mutations: {
    SET_UPDATE_FLAG_OF_TRANSACTION(state, payload) {
      state.flagOfTranUpdated = payload;
    },
    SET_TAGS(state, payload) {
      state.tags = payload;
    },
    SET_ALL_TAGS(state, payload) {
      console.log('payload', payload);
      state.allTags = payload;
    },
    SET_UPDATED_TAG(state, payload) {
      state.updatedTags = payload;
    },
    SET_TAGS_TRANSACTION(state, payload) {
      state.UserTransactionsTag = payload;
    },
    // UserTransactionsTagForAutoCategorizaiton
    SET_TAGS_TRANSACTION_AUTOCATEGORIZATION(state, payload) {
      state.UserTransactionsTagForAutoCategorizaiton = payload;
    },
    SET_LOADING(state, payload) {
      state.tagLoagind = payload;
    },
    SET_DELETE_TAG(state, payload) {
      state.tagDeleted = payload;
    },
  },
  actions: {
    getTags({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_TAGS,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getTagsdata) => {
          commit('SET_TAGS', getTagsdata.data.transacisonsTags);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((getTagserr) => {
          console.log(getTagserr);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    getAllTags({ commit }, payload) {
      apolloClient
        .query({
          query: GET_ALL_TAGS_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          if (data.transacisonsTags.length > 0) {
            data.transacisonsTags.forEach((tag, index) => {
              data.transacisonsTags[index].accountingTagTableId = null;
              data.transacisonsTags[index].agilLinkLevel2Id = null;
              if (tag.accountingTag) {
                data.transacisonsTags[index].accountingTagTableId = tag.accountingTag.id;
                if (tag.accountingTag.agilLinkOnline) {
                  data.transacisonsTags[index].agilLinkLevel2Id = tag.accountingTag.tagId;
                }
              }
            });
          }
          data.transacisonsTags = data.transacisonsTags.sort((a, b) => a.recordStatus - b.recordStatus);
          console.log('data.transacisonsTags', data.transacisonsTags);
          commit('SET_ALL_TAGS', { uniqueId: moment.now(), transacisonsTags: data.transacisonsTags });
        })
        .catch((getAllTagserr) => {
          console.log(getAllTagserr);
        });
    },

    //
    upsertTag({ commit }, payload) {
      let myId = '';
      if (payload.id) {
        myId = payload.id;
      }

      apolloClient
        .mutate({
          mutation: EDIT_UPDATE_TAG,
          variables: {
            ...payload,
            id: myId,
          },
        })
        .then((upsertTagdata) => {
          commit('SET_UPDATED_TAG', upsertTagdata.data.upserttransacisonsTag);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((upsertTagdataerr) => {
          console.log(upsertTagdataerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async getUserExpenseTags({ commit }, payload) {
      commit('SET_LOADING', true);

      await apolloClient
        .query({
          query: GET_TAGS_TRANSACTION,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getUserExpenseTagsdata) => {
          if (payload.variable === 'companyForAutoCategorization') {
            commit('SET_TAGS_TRANSACTION_AUTOCATEGORIZATION', getUserExpenseTagsdata.data.transacisonsTags);
          } else {
            commit('SET_TAGS_TRANSACTION', getUserExpenseTagsdata.data.transacisonsTags);
          }

          commit('SET_LOADING', false);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((getUserExpenseTagserr) => {
          console.log(getUserExpenseTagserr);
          commit('SET_LOADING', false);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    addTagToTransactions({ commit }, payload) {
      apolloClient
        .mutate({
          mutation: ADD_TAG_TRANSACTIONS,
          variables: {
            ...payload,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then((_data) => {
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((addTagToTransactionserr) => {
          console.log(addTagToTransactionserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    markFlagcmp({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: UPDATE_FLAG_OF_TRANSACTION,
          variables: {
            ...payload,
          },
        })
        .then((_) => {
          commit('SET_UPDATE_FLAG_OF_TRANSACTION', new Date());
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    deleteTag({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: SET_DELETE_TAG_GQL,
          variables: {
            ...payload,
            fetchPolicy: 'no-cache',
          },
        })
        .then((deleteTagdata) => {
          // inserted time property in object with unique dynamic value to trigger watcher every time this function being called.
          deleteTagdata.data.time = new Date()
          commit('SET_DELETE_TAG', deleteTagdata.data.updatetransacisonsTag);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((deleteTagerr) => {
          console.log(deleteTagerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
  },

  getters: {
    tags: state => state.tags,
    updatedTags: state => state.updatedTags,
    UserTransactionsTag: state => state.UserTransactionsTag,
    UserTransactionsTagForAutoCategorizaiton: state => state.UserTransactionsTagForAutoCategorizaiton,
    tagLoagind: state => state.tagLoagind,
    tagDeleted: state => state.tagDeleted,
    flagOfTranUpdated: state => state.flagOfTranUpdated,
    allTags: state => state.allTags,
  },
};
